// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__VTFxn","row":"Footer_row__H5eO4","voyagerLogo":"Footer_voyagerLogo__aiqub","links":"Footer_links__d-T9b","coopLogos":"Footer_coopLogos__LObx3"};